import { useNavigate, useParams } from 'react-router-dom';
import {
  CreateTermineDrawer,
  CreateTermineSheet,
  CreateTermineSheetWrapper,
  CreateTermineDrawerWrapper,
} from '@/domain/termine/features';
import { CreateTermineFormProvider } from '@/domain/termine/features/CreateTermin/shared/CreateTermineFormProvider';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

function CreateTermineContent() {
  const { isDesktop } = useCreateTermineFormContext();
  const navigate = useNavigate();
  const { year, month } = useParams<{ year: string; month: string }>();

  function handleClose() {
    navigate(`/termine/uebersicht/${year}/${month}`);
  }

  return isDesktop ? (
    <CreateTermineSheetWrapper onClose={handleClose}>
      <CreateTermineFormProvider>
        <CreateTermineSheet />
      </CreateTermineFormProvider>
    </CreateTermineSheetWrapper>
  ) : (
    <CreateTermineDrawerWrapper onClose={handleClose}>
      <CreateTermineFormProvider>
        <CreateTermineDrawer />
      </CreateTermineFormProvider>
    </CreateTermineDrawerWrapper>
  );
}

export function CreateTermineWrapper() {
  return (
    <CreateTermineFormProvider>
      <CreateTermineContent />
    </CreateTermineFormProvider>
  );
}
